import type React from 'react'

import css from './styles.module.css'

interface Props {
  url: string
}

export const SeoImage: React.FC<Props> = ({ url }) => (
  <div className={css.seo_image_wrap}>
    <img className={css.seo_image} src={url} alt="" />
  </div>
)
